"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var patientNotificationListForAdminView = function patientNotificationListForAdminView(dataSource, definitions, onChange, selectedFilters, getCurrentColumnSortOrder) {
  var columns = [{
    title: 'Notification Type',
    dataIndex: 'type',
    key: 'type',
    sorter: true,
    sortDirections: ['ascend', 'descend', 'ascend'],
    sortOrder: getCurrentColumnSortOrder('type'),
    filters: [{
      text: "Message from ".concat((0, _utils.getRoleName)(_utils.UserRoles.Doctor)),
      value: 'message-from-physician'
    }, {
      text: 'Message from Therapist',
      value: 'message-from-therapist'
    }, {
      text: 'Message from Admin',
      value: 'message-from-admin'
    }, {
      text: 'Treatment Plan',
      value: 'treatment-plan'
    }, {
      text: 'Therapy Recommendation',
      value: 'therapy-recommendation'
    }, {
      text: 'PatientMatched to Therapist',
      value: 'patient-matched-to-therapist'
    }, {
      text: "Patient matched to ".concat((0, _utils.getRoleName)(_utils.UserRoles.Doctor)),
      value: 'patient-matched-to-physician'
    }, {
      text: 'Detox Recommendation',
      value: 'detox-recommendation'
    }, {
      text: 'Clinician already on Call',
      value: 'clinician-already-on-call'
    }, {
      text: 'Upcoming appointment',
      value: 'appointment-upcoming'
    }, {
      text: 'Appointment rescheduled',
      value: 'appointment-rescheduled'
    }, {
      text: 'Appointment cancelled',
      value: 'appointment-cancelled'
    }, {
      text: 'Appointment in progress',
      value: 'appointment-in-progress'
    }, {
      text: 'Schedule appointmen',
      value: 'schedule-appointment'
    }, {
      text: "Schedule ".concat((0, _utils.getRoleName)(_utils.UserRoles.Doctor), " follow-up appointment"),
      value: 'schedule-physician-followup-appointment'
    }, {
      text: 'Upcoming intro call',
      value: 'upcoming-intro-call'
    }, {
      text: 'Sorry we missed you',
      value: 'sorry-we-missed-you'
    }, {
      text: 'Get new prescription',
      value: 'prescription-get-new'
    }, {
      text: 'Pharmacy prescription received',
      value: 'pharmacy-prescription-received'
    }, {
      text: 'Get prescription refill',
      value: 'prescription-get-refill'
    }, {
      text: "Patient rate ".concat((0, _utils.getRoleName)(_utils.UserRoles.Doctor), " call"),
      value: 'patient-rate-physician-call'
    }, {
      text: 'Patient rate Therapist call',
      value: 'patient-rate-therapist-call'
    }, {
      text: 'Patient rate Therapist monthly care',
      value: 'patient-rate-therapist-monthly-care'
    }, {
      text: 'Patient rate group call',
      value: 'patient-rate-group-call'
    }, {
      text: 'Group session one hour',
      value: 'group-session-1-hr'
    }, {
      text: 'Group session confirmed',
      value: 'group-session-confirmed'
    }, {
      text: 'Group session 24 hours',
      value: 'group-session-24-hr'
    }, {
      text: 'Group session 10 min',
      value: 'group-session-10-min'
    }, {
      text: 'Incompatible phone number',
      value: 'phone-number-incompatible'
    }],
    filteredValue: selectedFilters.type ? [selectedFilters.type] : null,
    filterMultiple: false,
    onFilter: function onFilter(value, record) {
      return value === record.type;
    },
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.type);
    },
    width: '170px',
    align: 'left',
    vertical: 'top'
  }, {
    title: 'Notification Channel',
    dataIndex: 'channel',
    key: 'channel',
    sorter: true,
    sortDirections: ['ascend', 'descend', 'ascend'],
    sortOrder: getCurrentColumnSortOrder('channel'),
    filters: [{
      text: 'Application',
      value: 'application'
    }, {
      text: 'SMS',
      value: 'SMS'
    }, {
      text: 'Email',
      value: 'email'
    }, {
      text: 'Chat',
      value: 'chat'
    }],
    filteredValue: selectedFilters.channel ? [selectedFilters.channel] : null,
    filterMultiple: false,
    onFilter: function onFilter(value, record) {
      return value === record.channel;
    },
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.channel);
    },
    width: '170px',
    align: 'center'
  }, {
    title: 'Notification Status',
    dataIndex: 'status',
    key: 'status',
    sorter: true,
    sortDirections: ['ascend', 'descend', 'ascend'],
    sortOrder: getCurrentColumnSortOrder('status'),
    filters: [{
      text: 'Pending',
      value: 'pending'
    }, {
      text: 'Pushed',
      value: 'pushed'
    }, {
      text: 'InternalError',
      value: 'internal-error'
    }, {
      text: 'Rejected',
      value: 'rejected'
    }, {
      text: 'Dismissed',
      value: 'dismissed'
    }, {
      text: 'Outdated',
      value: 'outdated'
    }, {
      text: 'Attempted',
      value: 'attempted'
    }, {
      text: 'Sent',
      value: 'sent'
    }, {
      text: 'Delivered',
      value: 'delivered'
    }, {
      text: 'Failed',
      value: 'failed'
    }, {
      text: 'Bounced',
      value: 'bounced'
    }, {
      text: 'Undelivered',
      value: 'undelivered'
    }, {
      text: 'Accepted',
      value: 'accepted'
    }, {
      text: 'Queued',
      value: 'queued'
    }, {
      text: 'Sending',
      value: 'sending'
    }, {
      text: 'Receiving',
      value: 'receiving'
    }, {
      text: 'Received',
      value: 'received'
    }],
    filteredValue: selectedFilters.status ? [selectedFilters.status] : null,
    filterMultiple: false,
    onFilter: function onFilter(value, record) {
      return value === record.status;
    },
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.status);
    },
    width: '170px',
    align: 'center'
  }, {
    title: 'Created At',
    dataIndex: 'createdAt',
    key: 'createdAt',
    sorter: true,
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, (0, _utils.formatDate)(record.createdAt, {
        withTime: true
      }));
    },
    width: '160px'
  }, {
    title: 'Updated At',
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    sorter: true,
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, (0, _utils.formatDate)(record.updatedAt, {
        withTime: true
      }));
    },
    width: '160px'
  }, {
    title: 'Details',
    dataIndex: 'details',
    key: 'details',
    sorter: false,
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record ? JSON.stringify(record).substr(0, 254) : '');
    },
    width: '200px',
    align: 'center'
  }, {
    title: 'Error Details',
    dataIndex: 'errorDetails',
    key: 'errorDetails',
    sorter: false,
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.errorDetails ? JSON.stringify(record.errorDetails).substr(0, 254) : '');
    },
    width: '200px',
    align: 'center'
  }];
  return {
    columns: columns,
    dataSource: dataSource,
    rowKey: 'id',
    onChange: onChange
  };
};
var _default = patientNotificationListForAdminView;
exports.default = _default;